import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("app_atkey");
    if (token) {
      config.headers.Authorization = `bearer ${token}`;
    }
    return config;
  },
  (err) => {
    return Promise.resolve(err);
  }
);

interface dataCommitment {
  CommitmentReducer: any[];
  error: string;
  success: boolean;
  isLoading: boolean;
}

const initialState: dataCommitment = {
  CommitmentReducer: [],
  error: "",
  success: false,
  isLoading: false,
};

const registerBazeFactory = createSlice({
  name: "CommitmentReducer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // هنگام ارسال درخواست
      .addCase(getCommitmentReducer.pending, (state) => {
        state.isLoading = true;
        state.error = "";
      })
      .addCase(getCommitmentReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.CommitmentReducer = action.payload;
        state.success = true;
      })
      .addCase(getCommitmentReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Something went wrong";
        state.success = false;
      })
      .addCase(addCommitmentReducer.fulfilled, (state, action) => {
        console.log(
          "Current state.CommitmentReducer type:",
          typeof state.CommitmentReducer,
          state.CommitmentReducer
        );
        if (Array.isArray(state.CommitmentReducer)) {
          state.CommitmentReducer.push(action.payload);
        } else {
          console.error(
            "CommitmentReducer is not an array:",
            state.CommitmentReducer
          );
        }
      })

      .addCase(deleteCommitmentReducer.fulfilled, (state, action) => {
        state.CommitmentReducer = state.CommitmentReducer.filter(
          (data: any) => data.dataID !== action.payload.dataID
        ); // حذف CommitmentReducer
      })
      // عملیات به‌روزرسانی CommitmentReducer
      .addCase(updateCommitmentReducer.fulfilled, (state, action) => {
        const index = state.CommitmentReducer.findIndex(
          (data) => data.dataID === action.payload.dataID
        );
        if (index !== -1) {
          state.CommitmentReducer[index] = action.payload; // به‌روزرسانی اطلاعات CommitmentReducer
        }
      });
  },
});

// ایجاد Thunks برای عملیات مختلف

// Thunk برای دریافت داده‌ها از سرور
export const getCommitmentReducer = createAsyncThunk(
  "CommitmentReducer/getCommitmentReducer",
  async (url: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(url);
      return response?.data?.items; // داده‌ها را از پاسخ axios استخراج می‌کنیم
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addCommitmentReducer = createAsyncThunk(
  "CommitmentReducer/addData",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://api.havirkesht.ir/commitment/",
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error adding data user:", error);
      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message || "Network Error";
        return rejectWithValue({
          message,
          status: error.response?.status,
        });
      }
      return rejectWithValue({
        message: "An unknown error occurred",
      });
    }
  }
);

export const deleteCommitmentReducer = createAsyncThunk(
  "datafactory/deleteData",
  async (dataID: string, { rejectWithValue }) => {
    try {
      await axios.delete(`https://api.havirkesht.ir/commitment/${dataID}`);
      return { dataID };
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

// Thunk برای به‌روزرسانی اطلاعات DataFactory
export const updateCommitmentReducer = createAsyncThunk(
  "datafactory/updateData",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `https://api.havirkesht.ir/commitment/${data}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log(error, "update");

      return rejectWithValue(error);
    }
  }
);

export const SMSCommitmentFarmerReducer = createAsyncThunk(
  "CommitmentReducer/addData",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `https://api.havirkesht.ir/sms/farmer-commission-sms/${data}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response, "SMS response✅");
      return response.data;
    } catch (error: any) {
      console.error("Error message for farmer has error:", error.message);
      if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message || "Network Error";
        return rejectWithValue({
          message,
          status: error.response?.status,
        });
      }
      return rejectWithValue({
        message: "An unknown error occurred",
      });
    }
  }
);
// صادرات اکشن‌ها و reducer
export default registerBazeFactory.reducer;
